import React from "react";
import styled from "styled-components";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumb from "./Breadcrumb";

const Main = styled.div`
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
`;

const Layout = ({ children }) => (
  <div>
    <Header />
    <Breadcrumb />
    <Main>{children}</Main>
    <Footer />
  </div>
);
export default Layout;
